import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {Button} from 'shells/button/button';
import {GoogleCalendarIcon} from 'shells/icon/svg/google-calendar-icon';
import {OutlookCalendarIcon} from 'shells/icon/svg/outlook-calendar-icon';

import type {CalendarSync} from 'nutshell-graphql-types';

import {useSelectCalendarSyncCalendar} from './graphql/hooks';
import {SelectCalendarModalWrapper} from './select-calendar-modal/select-calendar-modal-wrapper';

type Props = {
    calendarSync: CalendarSync;
};

export function ChangeCurrentCalendar(props: Props) {
    const [isChangingCalendar, setIsChangingCalendar] = React.useState(false);

    const {selectCalendarSyncCalendar} = useSelectCalendarSyncCalendar();

    const selectedCalendar = props.calendarSync.calendars.find((cal) => cal.syncType === 'PRIMARY');

    return (
        <>
            <ActionBox
                title={selectedCalendar ? selectedCalendar.name : 'No calendar selected'}
                shouldTruncate={true}
                icon={
                    props.calendarSync.externalService === 'OFFICE365' ? (
                        <OutlookCalendarIcon size={24} />
                    ) : (
                        <GoogleCalendarIcon size={24} />
                    )
                }
                actionElement={
                    props.calendarSync.calendars.length > 1 ? (
                        <div className='flex pr-24'>
                            <Button
                                variant='text-primary'
                                size='xlarge'
                                onClick={() => {
                                    setIsChangingCalendar(true);
                                }}
                                disabled={!props.calendarSync.isEnabled}
                            >
                                Change
                            </Button>
                        </div>
                    ) : null
                }
            />
            {isChangingCalendar && (
                <SelectCalendarModalWrapper
                    username={props.calendarSync.username}
                    isOpen={isChangingCalendar}
                    onClose={() => setIsChangingCalendar(false)}
                    onSave={(calendarId) => {
                        return selectCalendarSyncCalendar(calendarId);
                    }}
                    modalType='sync'
                />
            )}
        </>
    );
}
